<section class="sub-header">
  <!-- Show the back btn -->
  <button class="btn btn-back" (click)="location.back()">Back</button>
  <!-- Show the title -->
  <h2>Frequently Asked Questions</h2>
</section>
<app-faq-categories></app-faq-categories>
